import { memoryOnlyTicketSaveText } from '@/utils/offlineQueue';
import { memoryOnlyTicketRecoveryText } from '@/utils/ticketRecovery';
import { memoryOnlyTicketRetainedText } from '@/utils/ticketRetainedDrafts';

/** Synchronous snapshot admission before auth revokes a mounted form's author. */
export const TICKET_SESSION_SNAPSHOT_EVENT = 'ft:ticket-session-snapshot';

export interface TicketSessionSnapshot {
  revoke: boolean;
  dirtyCount: number;
  pending: Promise<boolean>[];
}

export function snapshotTicketForms(revoke = false): { dirtyCount: number; durable: Promise<boolean> } {
  const detail: TicketSessionSnapshot = { revoke, dirtyCount: 0, pending: [] };
  window.dispatchEvent(new CustomEvent(TICKET_SESSION_SNAPSHOT_EVENT, { detail }));
  return { dirtyCount: detail.dirtyCount, durable: Promise.all(detail.pending).then((results) => results.every(Boolean)) };
}

export function memoryOnlyTicketEditsText(owner: string | null): string {
  return [memoryOnlyTicketSaveText(owner), memoryOnlyTicketRecoveryText(owner), memoryOnlyTicketRetainedText(owner)]
    .filter(Boolean).join('\n\n');
}
